import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import LabelAndSelectForm from '../form/labelAndSelectForm';
import configLocal from '../../configuracao/configLocal';

import { getControladorGrupoList } from './selectdbAtions';

class SelectNumeroControlador extends Component {
  componentWillMount() {
    this.props.getControladorGrupoList();
  }

  numeroDisponivel(listCont, numero) {
    return !listCont.some(cont => numero === cont.numero_controlador);
  }

  renderOptions() {
    const listNumCont = this.props.list || [];

    const grupoFisicoId = configLocal.getConfig('grupo');
    const listCont = listNumCont.filter(
      cont => parseInt(grupoFisicoId, 10) === parseInt(cont.grupo_fisico_id, 10),
    );

    const list = [];

    if (listNumCont.length === 0) {
      list[0] = { id: 0, desc: '00' };
    }

    for (let i = 1; i <= 9; i += 1) {
      if (this.numeroDisponivel(listCont, i)) {
        list[i] = { id: i, desc: `0${i}` };
      }
    }

    for (let i = 10; i <= 99; i += 1) {
      if (this.numeroDisponivel(listCont, i)) {
        list[i] = { id: i, desc: i };
      }
    }

    for (let i = 100; i <= 220; i += 1) {
      if (this.numeroDisponivel(listCont, i)) {
        list[i] = { id: i, desc: i };
      }
    }

    return list.map(sequencia => (
      <option key={sequencia.id} value={sequencia.id}>
        {sequencia.desc}
      </option>
    ));
  }

  render() {
    return (
      <Field
        name={this.props.name}
        component={LabelAndSelectForm}
        label={this.props.label}
        cols={this.props.cols}
        validate={this.props.validate}
      >
        <option value="selecione">Selecione o número do controlador</option>
        {this.renderOptions()}
      </Field>
    );
  }
}

const mapStateToProps = state => ({ list: state.controladorCad.list });
const mapDispatchToProps = dispatch => bindActionCreators({ getControladorGrupoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectNumeroControlador);
